import React, { cloneElement } from 'react'
import { connect } from 'react-redux'

import {
  getActiveModal,
  NEW_SCREEN_MODAL,
  NEW_TABLE,
  NEW_RELATIONSHIP,
  TWO_FACTOR_MODAL,
  CUSTOM_ACTION_MODAL,
  INTEGRATION_TRIAL_MODAL,
  TERMS_OF_SERVICE_MODAL,
  DESIGN_VERSION_MODAL,
  CONFIRM_RESTORE_MODAL,
} from 'ducks/editor/modals'

import Modal from 'components/Shared/Modal'
import NewScreenModal from 'components/Editor/NewScreenModal'
import NewTableModal from 'components/Editor/NewTableModal'
import NewRelationshipModal from 'components/Editor/NewRelationshipModal'
import TwoFactorModal from 'components/Editor/Publish/TwoFactorModal'
import CustomActionModal from 'components/Editor/CustomActionModal'
import IntegrationTrialModal from 'components/Shared/TrialWarning/IntegrationTrialModal'
import TermsModal from 'components/Editor/TermsModal'
import DesignVersionModal from 'components/Editor/DesignVersionModal'
import ConfirmRestoreModal from 'components/Editor/ConfirmRestoreModal'

const ModalWrapper = ({ activeModal }) => {
  const handleSuccess = value => activeModal.resolve(value)
  const handleRejection = error => activeModal.reject(error)
  const handleClose = () => activeModal.resolve()

  const renderModal = (modal, modalProps = {}) => {
    return (
      <div className="modal-wrapper-wrapper">
        <Modal {...modalProps} scrolling onClose={handleClose}>
          {cloneElement(modal, {
            onSuccess: handleSuccess,
            onCancel: handleRejection,
            onClose: handleClose,
            opts: activeModal?.opts || {},
          })}
        </Modal>
      </div>
    )
  }

  if (!activeModal) return null

  switch (activeModal.modalType) {
    case NEW_SCREEN_MODAL: {
      return renderModal(<NewScreenModal />, { className: 'new-screen-modal' })
    }
    case NEW_TABLE: {
      return renderModal(<NewTableModal />)
    }
    case NEW_RELATIONSHIP: {
      return renderModal(<NewRelationshipModal />)
    }
    case TWO_FACTOR_MODAL: {
      return renderModal(<TwoFactorModal />, { size: 'xs' })
    }
    case CUSTOM_ACTION_MODAL: {
      return renderModal(<CustomActionModal />, { size: 'lg' })
    }
    case INTEGRATION_TRIAL_MODAL: {
      const { appId, type } = activeModal.opts

      return renderModal(<IntegrationTrialModal appId={appId} type={type} />, {
        size: 'lg',
      })
    }
    case DESIGN_VERSION_MODAL: {
      const {
        version,
        loadVersionsList,
        type,
        deleteVersion,
        handleRestoreVersion,
      } = activeModal.opts

      return renderModal(
        <DesignVersionModal
          version={version}
          loadVersionsList={loadVersionsList}
          type={type}
          deleteVersion={deleteVersion}
          restoreVersion={handleRestoreVersion}
        />,
        { size: 'sm' }
      )
    }
    case CONFIRM_RESTORE_MODAL: {
      const { restoreVersion } = activeModal.opts

      return renderModal(
        <ConfirmRestoreModal restoreVersion={restoreVersion} />,
        { size: 'sm' }
      )
    }
    case TERMS_OF_SERVICE_MODAL: {
      return renderModal(<TermsModal />, { size: 'sm', fixedHeight: true })
    }

    default: {
      return null
    }
  }
}

const mapStateToProps = state => ({
  activeModal: getActiveModal(state),
})

export default connect(mapStateToProps)(ModalWrapper)
